import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { AppRoutes } from 'router'
import { Header, Snackbar, SideBar } from 'components'
import { WrapContent, Wrap } from './Style'
import { WrapScreen } from 'styles/GlobalStyle'
import { WrapAlert } from 'components/Alerts'
import { useSelector } from 'react-redux'
import { audioTranscriptionRQ, StoreCrud, application, testTakerRQ } from 'store/hooks'
import { isEqual } from 'lodash'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { AbilityContext } from 'components/Permissions/Can'
import { useLocation, useNavigate } from 'react-router-dom'
import { secretStorage } from 'config'
import { ReactComponent as DoorIcon } from 'assets/icons/Door.svg';
import { ReactComponent as HomeIcon } from 'assets/icons/Home.svg';
import { SvgIcon } from '@mui/material'
import { alerts } from 'keys'
import { useAlert } from 'components/Alerts/hooks'
import { ContactUsButton } from 'pages/ContactUs'

const Main = () => {
    const { getTestTaker } = StoreCrud()
    const { setAlerts } = useAlert()

    const ability = useContext(AbilityContext)
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const { testTaker } = useSelector(state => state.testTaker)

    const setAppData = application.useInitAppData()
    const cleanAppData = application.useCleanAppData()

    const previousTestTaker = useRef(testTaker)
    const dispatch = useDispatch()

    const { } = audioTranscriptionRQ.useGetInit()
    const { } = testTakerRQ.useGetLanguages()

    const getTestTakerOnChange = async () => {
        if (testTaker?.test_taker_id && !isEqual(testTaker, previousTestTaker.current)) {
            const nTestTaker = await getTestTaker(testTaker.test_taker_id)
            previousTestTaker.current = nTestTaker
            dispatch(actions.setTestTaker(nTestTaker))
        }
    }

    const openExitScreenAlert = useCallback(() => {
        setAlerts(alerts.exitScreen, true)
    }, [])

    useEffect(() => {
        setAppData()
        const token = secretStorage.getItem("user")?.token
        if (token)
            dispatch(actions.setToken(token))
    }, [])

    useEffect(() => { getTestTakerOnChange() }, [testTaker])

    useEffect(() => {
        return (() => {
            cleanAppData()
        })
    }, [])

    const hideElementsInFeatures = {
        ["newsletters"]: {
            header: true,
        },
        ["tutorials"]: {
            header: true,
            padding: true
        },
        ["perform-assessments"]: {
            header: true,
            sideBar: true
        }
    }

    const featureName = pathSegments.length > 0 ? pathSegments[0] : null;
    const hideSidebar = hideElementsInFeatures?.[featureName]?.sideBar || false
    const hideToolbar = hideElementsInFeatures?.[featureName]?.header || false
    const hidePadding = hideElementsInFeatures?.[featureName]?.padding || false

    const showSidebar = ability.can("read", "sidebar") && !hideSidebar
    const showToolbar = ability.can("read", "toolbar") && !hideToolbar

    return (
        <WrapScreen>
            <WrapAlert />
            {/* {existAlert && openExitScreenAlert && <props.existAlert close={closeExitScreenAlert} accept={acceptExitScreenAlert} />} */}
            <Snackbar />
            {showSidebar && <SideBar />}
            {showToolbar && <Header />}
            {!showSidebar && !showToolbar &&
                <div className='go-home-icon' onClick={openExitScreenAlert}>
                    <SvgIcon fontSize='large' component={DoorIcon} inheritViewBox />
                </div>}
            {/* <ContactUsButton /> */}
            <Wrap showSidebar={showSidebar} showToolbar={showToolbar}>
                <WrapContent hidePadding={hidePadding} showSidebar={showSidebar} showToolbar={showToolbar}>
                    <AppRoutes />
                </WrapContent>
            </Wrap>
        </WrapScreen>
    )
}

export default Main


